module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("User")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.log.user),
      expression: "log.user"
    }],
    staticClass: "input is-disabled",
    attrs: {
      "type": "text",
      "name": "user",
      "id": "user"
    },
    domProps: {
      "value": (_vm.log.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.log, "user", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("IP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.log.ip),
      expression: "log.ip"
    }],
    staticClass: "input is-disabled",
    attrs: {
      "type": "text",
      "name": "ip",
      "id": "ip"
    },
    domProps: {
      "value": (_vm.log.ip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.log, "ip", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Method")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.log.method),
      expression: "log.method"
    }],
    staticClass: "input is-disabled",
    attrs: {
      "type": "text",
      "name": "method",
      "id": "method"
    },
    domProps: {
      "value": (_vm.log.method)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.log, "method", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Route")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.log.route),
      expression: "log.route"
    }],
    staticClass: "input is-disabled",
    attrs: {
      "type": "text",
      "name": "route",
      "id": "route"
    },
    domProps: {
      "value": (_vm.log.route)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.log, "route", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.log.url),
      expression: "log.url"
    }],
    staticClass: "input is-disabled",
    attrs: {
      "type": "text",
      "name": "url",
      "id": "url"
    },
    domProps: {
      "value": (_vm.log.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.log, "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.log.date),
      expression: "log.date"
    }],
    staticClass: "input is-disabled",
    attrs: {
      "type": "text",
      "name": "date",
      "id": "date"
    },
    domProps: {
      "value": (_vm.log.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.log, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.log.old_data || _vm.log.new_data) ? [_c('vue-json-compare', {
    attrs: {
      "oldData": _vm.log.old_data ? JSON.parse(_vm.log.old_data) : '',
      "newData": _vm.log.new_data ? JSON.parse(_vm.log.new_data) : ''
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ca5b1b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/logs/Log.vue
// module id = 1178
// module chunks = 39